import Axios from "./Axios";
import { buildPrescriptionComplaintsPath } from "./api-variables";

export async function fetchPrescriptionComplaints(userId) {
  const res = await Axios.get(buildPrescriptionComplaintsPath(userId));
  return Array.isArray(res.data) ? res.data : res.data?.results ?? [];
}
